export const currencyFormat = (str: string) => {
  if (str === '') str = '0'
  if (!isNaN(parseInt(str.charAt(0)))) {
    str = str.replace('R$', '')
    str = str.slice(1, str.length) + str.charAt(0)
  }
  const value = parseInt(str.replace(/[^\d]+/gi, ''), 10) / 100
  const valueFixed = value.toFixed(2)
  const valueNumber = parseFloat(valueFixed)

  const getCurrencyFormat = () => {
    if (!value) {
      return 'R$ 0,00'
    }

    return new Intl.NumberFormat('pt-br', {
      style: 'currency',
      currency: 'BRL',
    }).format(valueNumber)
  }

  return getCurrencyFormat()
}

export const usdCurrencyFormat = (str: string) => {
  if (str === '') str = '0'
  const value = parseInt(str.replace(/[^\d]+/gi, ''), 10) / 100
  const valueFixed = value.toFixed(2)
  const valueNumber = parseFloat(valueFixed)

  const getCurrencyFormat = () => {
    if (!value) {
      return ''
    }

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    })
      .format(valueNumber)
      .replace('$', '')
  }

  return getCurrencyFormat()
}

export const fiatFormat = (number: number) => {
  const numberRounded = Math.round(number * 100) / 100
  const numberFormatted = numberRounded.toFixed(2)
  const value = numberFormatted.replace('.', ',')

  return value
}

export const currencyTocents = (formattedValue: string): number => {
  if (!formattedValue || formattedValue === '') {
    return 0
  }
  const valueInCents = parseInt(formattedValue.replace(/[^\d]+/gi, ''), 10) || 0
  return valueInCents
}

export const centsToCurrency = (cents: number): string => {
  const value = cents / 100
  return value.toFixed(2).replace('.', ',')
}
